import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { BenefitsBento } from '../components/BenefitsBento';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
import { StaticConnectionsBeat } from '../components/StaticConnectionsBeat';
import { TwelveTabProblem } from '../components/TwelveTabProblem';
import { WorkYouCantGetTo } from '../components/WorkYouCantGetTo';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-6126" />
      {/* <NovaSection /> Hidden per user request */}
      {/* "What Giga can do" overview — the bento leads the page right after the
                       hero so cold ad/UGC traffic gets the answer ("what is this, and it
                       actually does the work") before anything else. */}
      {/* "AI adoption fails without an AI brain" capability grid. Hidden for
                       now per request; may return later. Import + component are preserved so
                       no data is lost — just re-enable the <CapabilityGrid /> below.
                       <CapabilityGrid /> */}
      <BenefitsBento data-id="element-6127" />
      {/* Problem statement as a CONTRAST beat — "the world without Giga" (11
                               tabs / context-switch tax). Placed right after the bento "what it
                               is" so it reframes the pain the ad already sold, then hands off to
                               the easy 2-minute setup. Leading with the answer (not the problem)
                               is intentional for ad/UGC traffic that arrives pre-sold on the pain. */}
      <TwelveTabProblem data-id="element-6128" />
      {/* Bridge beat — "Giga lives in the chats." Shows Giga answering right
                               inside Slack (reactive: it answers when asked), setting up the
                               proactive autonomy payoff later in the page. */}
      <LivesInSlack data-id="element-6129" />
      {/* "How it works" / Plug-and-play — the relief that follows the problem
                               beat, before the Giga for You / Team audience switch. */}
      <GettingStartedSteps data-id="element-6130" />
      <AudienceSwitch data-id="element-6131" />
      {/* StaticConnectionsBeat ("Shared intelligence across your stack") removed
                       from the home flow — its logo marquee + "See all integrations" CTA was a
                       redundant third take on integration breadth (already covered by the hero
                       marquee and the bento "Connects in seconds" card). Import preserved for
                       reuse: <StaticConnectionsBeat /> */}
      {/* Proactive autonomy payoff — "You didn't ask, Giga noticed." The biggest
                         capability claim, now on a CALM cream surface. Opens the finale's
                         gentle descent into the CTA. */}
      <WorkYouCantGetTo data-id="element-6132" />
      {/* Finale energy ramp: calm cream proof (WorkYouCantGetTo) → calm cream
                         social proof (WallOfLove) → bold orange founder conviction
                         (NarrativeSection) → dark confident close (ClosingCTA). WallOfLove now
                         sits BEFORE the founder beat so the bright orange reads as a deliberate
                         crescendo right before the dark CTA, not an interruption between two
                         cream sections. */}
      <ToolComparison data-id="element-6133" />
      <WallOfLove data-id="element-6134" />
      <NarrativeSection data-id="element-6135" />
      {/* <PricingSection /> Hidden from home for now — still a waitlist. Kept
                                                           for reuse; bring back when pricing goes live. */}
      <ClosingCTA data-id="element-6136" />
    </>;
}